export class CONSTANT_NAVIGATOR {
  static navigator_rc = {
    'DJI_RC_PLUS_2': 'DJI RC PLUS 2',
    'DJI_RC_PLUS': 'DJI RC Plus',
    'DJI_RC_PRO_E': 'DJI RC Pro Entreprise',
  }

  static navigator_computer = {
  }


  static navigator_milestone = {
  }

  /** -------------------------- */

  static get() {
    return {
      navigator_rc: this.navigator_rc,
      navigator_computer: this.navigator_computer,
      navigator_milestone: this.navigator_milestone,
    }
  }
}
